import { render, staticRenderFns } from "./modifyColor.vue?vue&type=template&id=10b489b5&scoped=true"
import script from "./modifyColor.vue?vue&type=script&lang=js"
export * from "./modifyColor.vue?vue&type=script&lang=js"
import style1 from "./modifyColor.vue?vue&type=style&index=1&id=10b489b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b489b5",
  null
  
)

export default component.exports